export enum ApplicationFormSchemaOAuthParamFields {
  TYPE = 'type',
  NAME = 'name',
  DISPLAY_NAME = 'display_name',
  FORM_FIELD_NAME = 'form_field_name',
}
